/**
 * 将Date对象转为
 * https://www.30secondsofcode.org/js/s/to-iso-string-with-timezone
 */
export const toISOStringWithTimezone = (date: Date) => {
  const tzOffset = -date.getTimezoneOffset()
  const diff = tzOffset >= 0 ? '+' : '-'
  const pad = n => `${Math.floor(Math.abs(n))}`.padStart(2, '0')
  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    'T' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds()) +
    diff + pad(tzOffset / 60) +
    ':' + pad(tzOffset % 60)
}

export function formatTime (dateObj: Date | string, fmt = 'yyyy-MM-dd hh:mm', option?: { useUTCTime?: boolean }) {
  if (typeof dateObj === 'string') {
    dateObj = new Date(dateObj)
  }
  const o = {
    'M+': option?.useUTCTime ? dateObj.getUTCMonth() + 1 : dateObj.getMonth() + 1, // 月份
    'd+': option?.useUTCTime ? dateObj.getUTCDate() : dateObj.getDate(), // 日
    'h+': option?.useUTCTime ? dateObj.getUTCHours() : dateObj.getHours(), // 小时
    'm+': option?.useUTCTime ? dateObj.getUTCMinutes() : dateObj.getMinutes(), // 分
    's+': option?.useUTCTime ? dateObj.getUTCSeconds() : dateObj.getSeconds(), // 秒
    'q+': Math.floor((option?.useUTCTime ? dateObj.getUTCMonth() + 3 : dateObj.getMonth() + 3) / 3), // 季度
    S: option?.useUTCTime ? dateObj.getUTCMilliseconds() : dateObj.getMilliseconds(), // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length),
    )
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length),
      )
    }
  }
  return fmt
}